import React from "react";
import "./MiscellaneousInsurance.scss";
import misInsurance from "../../../assets/Services/mis-service.png";
import misImg from "../../../assets/Services/mis-img.png";

const MiscellaneousInsurance = () => {
  return (
    <>
      <div className="miscellaneous_service">
        <div className="container-fluid p-0">
          <div
            className="back_bg"
            style={{ backgroundImage: `url(${misInsurance})` }}
          ></div>
          <div className="heading_box">Miscellaneous Insurance</div>
          <div className="service_content">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 my-auto">
                  <div className="left mb-4 mb-lg-0">
                    <h4>MISCELLANEOUS INSURANCES</h4>
                    <ul>
                      <li>Burglary</li>
                      <li>Cash in Safe, Cash in Transit, Cash on Counter.</li>
                      <li>Cash in Premises.</li>
                      <li>Fidelity Guarantee.</li>
                      <li>All Risks</li>
                      <li>Product Liability</li>
                      <li>Public Liability</li>
                      <li>Workmen’s Compensation.</li>
                      <li>Employer’s Liability</li>
                      <li>Marine Terminal Operators Liability (MTOL)</li>
                      <li>Comprehensive General Liability</li>
                      <li>Hole in One (Golf) Insurance I Event Cover</li>
                      <li>Hotel Owner’s All Risks (HOAR)</li>
                      <li>Personal Accident</li>
                      <li>Personal Accident (Air Travel)</li>
                      <li>Health Insurance</li>
                      <li>Overseas Mediclaim</li>
                      <li>Business and Holiday (B&H)</li>
                      <li>Corporate Frequent Travels (CFT)</li>
                      <li>Employment and Study (E&S)</li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-6 my-auto">
                  <img src={misImg} className="img-fluid" alt="" />
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
    </>
  );
};

export default MiscellaneousInsurance;
